import dayjs from '../../../shared/services/dayjs.js';
import { Egfz } from '../../../shared/services/Egfz.js';
import { zeigeKleineNachricht } from './systemNachricht.js';
/**
 * Entfernt eine Zeile aus der Tabelle für den Zeitblockinput
 * @param {*} event
 */
function entferneZeitblockZeile(event) {
	const { rowIndex } = event.currentTarget.parentElement.parentElement;
	const table = document.getElementById('zeiten-tabelle');
	// Wenn nur eine Zeile übrig ist, soll diese nicht gelöscht werden.
	if (table.rows.length <= 2) {
		return zeigeKleineNachricht('Ein Zeitblock muss übrig bleiben!');
	}
	table.deleteRow(rowIndex);
	// Renummerierung der Zeilen
	for (let i = 1; i < table.rows.length; i += 1) {
		table.rows[i].id = `tr:${i}`;
		table.rows[i].children[0].innerText = i;
		// von Spalte update counter und onchange
		table.rows[i].children[1].children[0].id = `${i}:von`;
		table.rows[i].children[1].children[0].setAttribute('onchange', `fun.zeitDifferenzHTML(${i})`);
		// bis Spalte update counter und onchange
		table.rows[i].children[2].children[0].id = `${i}:bis`;
		table.rows[i].children[2].children[0].setAttribute('onchange', `fun.zeitDifferenzHTML(${i})`);
		table.rows[i].children[3].children[0].id = `${i}:egfz`;
		table.rows[i].children[4].id = `${i}:gesamt`;
	}

	const datum = document.getElementById('input-datum').innerText;
	return updateSchichtGesamtInput(datum);
}

/**
 * Berechnet die einzelne Tabellenzeilenzeiten
 * @param {int} counter Tabellenzeile
 */
function zeitDifferenzHTML(counter) {
	let start = document.getElementById(`${counter}:von`).value;
	let ende = document.getElementById(`${counter}:bis`).value;
	const differenz = dayjs.getDurationHHmm(start, ende);
	const gesamt = document.getElementById(`${counter}:gesamt`);
	gesamt.innerText = dayjs.duration(differenz, 'minutes').format('HH:mm');

	// Berechne beim input auch die Gesamtzeit
	updateSchichtGesamtInput();
}

/**
 * Updated die angezeigte gesamte Schichtzeit beim Editieren und Erstellen von Schichten
 */
function updateSchichtGesamtInput() {
	const tabelle = document.getElementById('zeiten-tabelle');
	let gesamtStart = document.getElementById('1:von').value;
	let gesamtEnde = document.getElementById(`${`${tabelle.rows.length}` - 1}:bis`).value;
	const gesamtDifferenz = dayjs.getDurationHHmm(gesamtStart, gesamtEnde);
	document.getElementById('schicht-gesamt').innerText = dayjs.duration(gesamtDifferenz, 'minutes').format('HH:mm');
;
}

/**
 * Erstellt eine neue Zeile in der Zeitblocktabelle bei der Schichterstellung/-bearbeitung
 * @param {int} type beschreibt ob es sich um erstellen (0) oder editieren (1) der Schicht handelt
 */
function neuerZeitblockInput(type = 1) {
	const table = document.getElementById('zeiten-tabelle');
	let alteZeit = '00:00';
	const counter = table.rows.length;
	const dummyDate = dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).hour(0).minute(0);
	const dummyZeitblock = {
		BlockVon: dummyDate,
		BlockBis: dummyDate,
		BlockZeit: 0,
		EgfzID: 1,
	};
	const str = erstelleZeitblockZeile(dummyZeitblock, counter);
	table.insertAdjacentHTML('beforeend', str);
	if (type !== 0) {
		alteZeit = table.rows[table.rows.length - 2].children[2].children[0].value;
		table.rows[table.rows.length - 1].children[1].children[0].value = alteZeit;
		table.rows[table.rows.length - 1].children[2].children[0].value = alteZeit;
	}
}

/**
 * Legt eine neue Zeittabelle an für ein offenes Ende mit Sollstunden des Mitarbeiters (Standard 8h für die Vorlage)
 * @param {object} schicht aktuelles Schichtobjekt (vorauswahl aus dem Kalender)
 * @param {boolean} offenesEnde falls true => bis Zeit schätzen, falls false => von Zeit schätzen
 * @param {object} mitarbeiter aktuelles Mitarbeiterobjekt (undefined für die Vorlage)
 */
function offenerZeitblock(schicht, offenesEnde, mitarbeiter = undefined, ganztags = false) {
	// Bei ganztagsschichten keine Sollstunden
	let sollstunden = ganztags ? 0 : 8;
	if (mitarbeiter && !ganztags) {
		sollstunden = mitarbeiter.Beschaeftigung[0].SollstundenTag;
	}
	if (offenesEnde || ganztags) {
		// wir nehmen den Eintrag der ersten Von Uhrzeit als gesetzten Start für die Schicht
		const schichtVonHHMM = ganztags ? ['00', '00'] : document.getElementById('1:von').value.split(':');
		const schichtVonDatum = dayjs(schicht.Datum).hour(schichtVonHHMM[0]).minute(schichtVonHHMM[1]);
		schicht.SchichtVon = schichtVonDatum.toDate();
		schicht.SchichtBis = schichtVonDatum.add(sollstunden, 'hours').toDate();
	} else {
		// wir nehmen den Eintrag der ersten Bis Uhrzeit als gesetztes Ende für die Schicht
		const schichtBisHHMM = ganztags ? ['00', '00'] : document.getElementById('1:bis').value.split(':');
		const schichtBisDatum = dayjs(schicht.Datum).hour(schichtBisHHMM[0]).minute(schichtBisHHMM[1]);
		schicht.SchichtBis = schichtBisDatum.toDate();
		schicht.SchichtVon = schichtBisDatum.subtract(sollstunden, 'hours').toDate();
	}
	schicht.Zeitbloecke = [
		{
			BlockVon: schicht.SchichtVon,
			BlockBis: schicht.SchichtBis,
			EgfzID: Egfz.Arbeit,
		},
	];
	erstelleZeitblockTabelle(schicht, 0);
}

/**
 * Erstellt eine Zeilte des Zeitblock Inputs für die Oberfläche
 * @param {object} zeitblock Zeitblock Objekt mit von bis Daten und EGFZ ID.
 * @param {int} counter für die Nummerierung der Zeile
 * @returns HTML String der Zeile mit allen Infos
 */
 function erstelleZeitblockZeile(zeitblock, counter) {
	const htmlString = `<tr id="tr:${counter}" class="zeitblock-zeile"> `
				+ `<td> ${counter} </td>`
				+ `<td> 
						<input id="${counter}:von" type="time" class="schicht-input" 
							value=${dayjs(zeitblock.BlockVon).tz().format('HH:mm')} onchange="fun.zeitDifferenzHTML(${counter})"> 
					</td>`
				+ `<td> 
						<input id="${counter}:bis" type="time" class="schicht-input"
							value=${dayjs(zeitblock.BlockBis).tz().format('HH:mm')} onchange="fun.zeitDifferenzHTML(${counter})"> 
					</td> `
				+ `<td> 
						<select id="${counter}:egfz" class="schicht-input">
							<option value="${Egfz.Arbeit}" ${zeitblock.EgfzID === Egfz.Arbeit ? 'selected="selected"' : ''}>Arbeit</option>
							<option value="${Egfz.PauseUnbezahlt}" ${zeitblock.EgfzID === Egfz.PauseUnbezahlt ? 'selected="selected"' : ''}>Pause (unbezahlt)</option>
							<option value="${Egfz.PauseBezahlt}" ${zeitblock.EgfzID === Egfz.PauseBezahlt ? 'selected="selected"' : ''}>Pause (bezahlt)</option>
						</select>
					</td>`
				+ `<td id="${counter}:gesamt"> ${dayjs.duration(zeitblock.BlockZeit, 'hour').format('HH:mm')} </td> `
				+ '<td> <i class="bi bi-x-circle-fill remove-row" onclick="fun.entferneZeitblockZeile(event)"></i> </td> </tr>';
	return htmlString;
}

function erstelleZeitblockTabelle(schicht, type) {
	const zeitblockTabelleTemplate = document.querySelector('[template-zeiten-tabelle]');
	// table reset
	const oldTable = document.getElementById('input-zeiten-tabelle');
	if (oldTable !== null) {
		oldTable.remove();
	}

	const tabelle = zeitblockTabelleTemplate.content.cloneNode(true).children[0];
	// Wir schieben die Tabelle vor die Anzeige der Gesamten Schichtzeit ein.
	const zeitenSumme = document.getElementById('zeitblock-summe');
	zeitenSumme.insertAdjacentElement('beforebegin', tabelle);

	// für jeden vorhandenen Zeitblock wird eine Tabellenzeile eingefügt
	if (schicht.Zeitbloecke.length >= 1) {
		let counter = 1;
		schicht.Zeitbloecke.forEach((block) => {
			let row = '';
			row += erstelleZeitblockZeile(block, counter);
			document.getElementById('zeiten-tabelle').insertAdjacentHTML('beforeend', row);
			// Berechne die Zeiten jeder Zeile nachm Einfügen
			zeitDifferenzHTML(counter);
			counter += 1;
		});
	} else {
		// falls es keinen Zeitblock gibt, erstellen wir eine erste leere Tabellenzeile
		neuerZeitblockInput(type);
	}
	updateSchichtGesamtInput(document.getElementById('input-datum').innerText);
}

/**
 * Erstellt ein neues Zeitblock Objekt, um neue Dienstzeiten zu speichern
 * @returns leeren Zeitblock als Objekt
 */
function neuesZeitblockObjekt() {
	return {
		BlockVon: '',
		BlockBis: '',
		EgfzID: '',
	};
}

export {
 entferneZeitblockZeile,
 neuerZeitblockInput,
 neuesZeitblockObjekt,
 updateSchichtGesamtInput,
 erstelleZeitblockZeile,
 erstelleZeitblockTabelle,
 zeitDifferenzHTML,
 offenerZeitblock,
};
